"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importDefault(require("./colors"));
exports.colors = colors_1.default;
var spacing_1 = __importDefault(require("./spacing"));
exports.spacing = spacing_1.default;
var fonts_1 = __importDefault(require("./fonts"));
exports.fonts = fonts_1.default;
var misc_1 = __importDefault(require("./misc"));
exports.misc = misc_1.default;
//# sourceMappingURL=index.js.map